/* Add Product associations here */

var upsellProducts = {
  'spivo-stick': ['tilt-phone-mount','xclear-water-repellent','destination-packable-travel-day-backpack'],
  'everyday-adventurer-bundle':['destination-packable-travel-day-backpack','hip-pack-for-gopro','packing-cube-for-cameras'],
  'flexible-tripod-for-gopro': ['tripod-phone-mount','hip-pack-for-gopro','packing-cube-for-cameras'],
  'flexible-tripod-handgrip': ['destination-packable-travel-day-backpack','hip-pack-for-gopro','packing-cube-for-cameras'],
  'gopro-adventurer-bundle': ['flexible-tripod-for-gopro','clarifii-lens-water-spot-repellent-for-gopro','destination-packable-travel-day-backpack','hip-pack-for-gopro','packing-cube-for-cameras'],
  'underwater-hero-bundle':['flexible-tripod-for-gopro'],
  'ultimate-gopro-traveler-bundle':['tilt-phone-mount','3-easy-tighten-screws-for-gopro','spivo-flexible-travel-hat'],
  'destination-packable-travel-day-backpack':['hip-pack-for-gopro','packing-cube-for-cameras'],
  'hip-pack-for-gopro':['pocket-pro-tripod','3-easy-tighten-screws-for-gopro','xclear-water-repellent','destination-packable-travel-day-backpack'],
  'packing-cube-for-cameras':['pocket-pro-tripod','3-easy-tighten-screws-for-gopro','xclear-water-repellent','destination-packable-travel-day-backpack'],
  'pocket-pro-tripod':['tripod-phone-mount','hip-pack-for-gopro','packing-cube-for-cameras'],
  'epic-video-edit':['3-highlight-reels-pack-add-on','60s-highlight-video-edit','epic-video-edit'],
  'spivo-wedding-video-edit':['3-highlight-reels-pack-add-on','60s-highlight-video-edit']
}
/* END - Product associations */

var cartUpsell = (function($) {
  var selectors = {
    cartItems: '#sidecart .cart-items',
    sidecartBenefits: '#sidecart .sidecart-benefits',
    addOnHeader: '#sidecart .addon-header',
    upsellItem: '#sidecart .upsell-item',
    upsellOptions: '#sidecart .upsell-item select',
    upsellAddToCart: '#sidecart .upsell-item .add-to-cart'
  };
  var cart = {};
  var upsellsShown = [];
  
  function refreshUpsell() {
    // Cart Add on header
    $(selectors.addOnHeader)[($(".cart-items.addons.regular-addons .cart-item.upsell-item").length == 0) ? 'addClass' : 'removeClass']('hidden');
    if( $(".cart-items.addons.regular-addons .cart-item.upsell-item").length == 0 && $(".cart-item.upsell-item.video-upsell").length == 0){
    	$("#sidecart").addClass("addons-empty");
    } else {
    	$("#sidecart").removeClass("addons-empty");
    }
  }
  
  function addUpsellToCart(handle) {
    // Add On Header
    $(selectors.addOnHeader).removeClass('hidden');
    
    // If already shown as upsell, return
    if (upsellsShown.indexOf(handle) > -1) {
      return;
    }
    
    upsellsShown.push(handle);
    $.getJSON('/products/' + handle + '.js', function(productData) {
      //console.log( productData );
      console.log(window.video_item_count);
      if ( handle == "epic-video-edit" ){
        if (video_bogo ){
        //VIDEO UPSELL
     	 $("#sidecart .cart-items.addons.bogo-addon").prepend("\
		  <h4 style='font-weight: 300'>Buy <strong>Two</strong> Edits Get One <strong style='color:#f43510'>Free</strong></h4>\
          <div class='cart-item upsell-item video-upsell' data-handle='" + productData.handle + "' data-id='" + productData.id + "'>\
            <div class='thumb-wrapper'>\
                <img src='https://cdn.shopify.com/s/files/1/0777/5743/products/FREE-Spivo-Video-edit-epic-styling.jpg?v=1632436124' />\
            </div>\
			<div class='item-details'>\
			<h5>" + productData.title + "</h5>\
			<p class='description'>Order now and upload whenever you want, there's no time limit.</p>\
			</div>\
            <div class='options-wrapper'>\
            </div>\
          </div>");
        }
        if (video_min_bundle && window.video_item_count < video_max_bundle_qty ){
          //VIDEO UPSELL MIN BUNDLE
     	 $("#sidecart .cart-items.addons.bogo-addon").prepend("\
		  <h4 style='font-weight: 300'>Buy <strong>More</strong> Save <strong style='color:#f43510'>More!</strong></h4>\
          <div class='cart-item upsell-item video-upsell bundles' data-handle='" + productData.handle + "' data-id='" + productData.id + "'>\
            <div class='thumb-wrapper'>\
                <img src='https://cdn.shopify.com/s/files/1/0777/5743/products/FREE-Spivo-Video-edit-epic-styling.jpg?v=1632436124' />\
            </div>\
			<div class='item-details'>\
			<h5>" + productData.title + "</h5>\
			<p class='description'>Order now and upload whenever you want, there's no time limit and you can make adjustments.</p>\
			</div>\
            <div class='options-wrapper'>\
            </div>\
          </div>");
        }
      } else if( handle == "60s-highlight-video-edit" ){
      	//Video upsell
         $("#sidecart .cart-items.addons.regular-addons").append("\
          <div class='cart-item upsell-item' data-handle='" + productData.handle + "' data-id='" + productData.id + "'>\
            <div class='thumb-wrapper'>\
                <img src='" + productData.images[0] + "' />\
            </div>\
            <div class='item-details'>\
              <h5>" + productData.title + "</h5>\
			  <p class='description'>Perfect to share a short highlight version of your video with friends a family.</p>\
              <p class='price'>" + Shopify.formatMoney( productData.price , Theme.moneyFormat) + " <s>"+ Shopify.formatMoney( 14900 , Theme.moneyFormat) +"</s></p>\
            </div>\
            <div class='options-wrapper'>\
            </div>\
          </div>");
      } else if( handle == "3-highlight-reels-pack-add-on" ){
      	//Video upsell
         $("#sidecart .cart-items.addons.regular-addons").append("\
          <div class='cart-item upsell-item' data-handle='" + productData.handle + "' data-id='" + productData.id + "'>\
            <div class='thumb-wrapper'>\
                <img src='" + productData.images[0] + "' />\
            </div>\
            <div class='item-details'>\
              <h5>" + productData.title + "</h5>\
			  <p class='description'>We curate 3 Reels/TikToks of the best moments of your video.</p>\
              <p class='price'>" + Shopify.formatMoney( productData.price , Theme.moneyFormat) + " <s>"+ Shopify.formatMoney( 44700 , Theme.moneyFormat) +"</s></p>\
            </div>\
            <div class='options-wrapper'>\
            </div>\
          </div>");
      } else if(extra_savings){
        //PRODUCT UPSELL DURING SALE
        $("#sidecart .cart-items.addons.regular-addons").append("\
          <div class='cart-item upsell-item' data-handle='" + productData.handle + "' data-id='" + productData.id + "'>\
            <div class='thumb-wrapper'>\
                <img src='" + productData.images[0] + "' />\
            </div>\
            <div class='item-details'>\
              <h5><a href='/products/"+ productData.handle +"'>" + productData.title + "</a></h5>\
              <p class='price'>" + Shopify.formatMoney( productData.price * 0.80 , Theme.moneyFormat) + " <s>" + Shopify.formatMoney( productData.price , Theme.moneyFormat) + "</s></p>\
            </div>\
            <div class='options-wrapper'>\
            </div>\
          </div>");
      } else {
        //NORMAL PRODUCT UPSELL
         $("#sidecart .cart-items.addons.regular-addons").append("\
          <div class='cart-item upsell-item' data-handle='" + productData.handle + "' data-id='" + productData.id + "'>\
            <div class='thumb-wrapper'>\
                <img src='" + productData.images[0] + "' />\
            </div>\
            <div class='item-details'>\
              <h5><a href='/products/"+ productData.handle +"'>" + productData.title + "</a></h5>\
              <p class='price'>" + Shopify.formatMoney( productData.price , Theme.moneyFormat) + "</p>\
            </div>\
            <div class='options-wrapper'>\
            </div>\
          </div>");
      }
      // Add options and add to cart Button
      var optionsWrapper = '.upsell-item[data-id="' + productData.id + '"] .options-wrapper';
      if (productData.variants.length > 1) {
        var options = "<select class='select'></select>";
        var sel = $('<select>').appendTo(optionsWrapper);
        _.each(productData.variants, function(variant) {
          sel.append($("<option>").attr('value', variant.id).text(variant.title));
        });
      }
      var videoUpsellElementId = "";
      var btnText = "Add";
      var addQty = "1";
      var variantID = productData.variants[0].id;
      //console.log( "handle is " + handle );
      if ( handle == "epic-video-edit" && video_bogo ){
        //console.log( $(".video-edit-item:last a").data("id") );
       variantID = $(".video-edit-item:not(.free-video):first a").data("id");
       //console.log("select id is " + variantID );
       $(".video-upsell select").val( variantID );
       videoUpsellElementId = 'id="videoUpsell"';
        if(window.video_item_count < 4 ){ 
          if ( window.video_item_count % 3 == 1 ){
           btnText = "Add 1 more get 1 Free";
           addQty = "2"; 
          } else if ( window.video_item_count % 3 == 2 ){
           btnText = "Add 1 more for Free";
           addQty = "1"; 
          } else if ( window.video_item_count % 3 == 0 ){
           btnText = "Add 2 more get 1 Free";
           addQty = "3"; 
          }
        } else if(window.video_item_count < 10 ) {
           var bulkQty = 10 - window.video_item_count;
          	$(".cart-items.addons.bogo-addon h4").html("Buy <strong>10</strong> Edits Get <strong style='color:#f43510'>40% off</strong>");
           btnText = "Add " + bulkQty + " get 40% off";
           addQty = bulkQty; 
        } else {
          $(".cart-items.addons.bogo-addon").hide();
        }
      }
      if ( handle == "epic-video-edit" && (video_min_bundle || video_max_bundle) ){
        if (video_min_bundle_code == "BUY2GET1FREE"){
          if ( window.video_item_count == 1 ){
           btnText = "Add 1 get 1 free";
           addQty = "2";
           }
        if ( window.video_item_count == 2 ){
           btnText = "Add 1 for 1 free";
           addQty = "1";
        }
        } else {
        if ( window.video_item_count == 1 ){
           btnText = "Add 2 more get 33% Off";
           addQty = "2";
        }
        if ( window.video_item_count == 2 ){
           btnText = "Add 1 more get 33% Off";
           addQty = "1";
        }
        }
        if ( window.video_item_count >= 3 && video_max_bundle && window.video_item_count < video_max_bundle_qty ){
           btnText = "Add "+ (video_max_bundle_qty - window.video_item_count) +" more get 40% Off";
           addQty = video_max_bundle_qty - window.video_item_count;
        }
      }
      if ( $("input[variant-id='" + variantID + "']").length == 0 ){
      var addToCart = $('<input type="submit" addqty="' + addQty + '" ' + videoUpsellElementId + ' value="' + btnText + '" class="button add-to-cart" data-variant-id="' + variantID + '">').appendTo(optionsWrapper);
      }
        refreshUpsell();
    });
  }
  
  function removeUpsellFromCart(handle) {
    var $upsell = $(selectors.upsellItem + '[data-handle="' + handle + '"]');
    if ($upsell.length) {
      $upsell.remove();

      // Remove from upsellsShown variable
      var index = upsellsShown.indexOf(handle);
      if (index > -1) {
        upsellsShown.splice(index, 1);
      }      
    }

    refreshUpsell();
  }
  
  function update(cartData) {
    upsellsShown = [];
    cart = cartData;
    
    _.each(upsellProducts, function(upsells, product) {
      // AB - loop through multiple upsells //
      //console.log(upsellsShown);
      var isProductInCart = checkIfCartHasProduct(product, true);
      var  i;
      var  upsell;
      for(i = 0; i < upsells.length; i++){
        upsell = upsells[i];
      //console.log(upsell);
      var isUpsellInCart = checkIfCartHasProduct(upsell, false);
        //console.log(upsell + " upsell in cart: " + isUpsellInCart);
        //console.log(product + " product is in cart: " + isProductInCart);
        
      var $upsellItem = $(selectors.upsellItem + '[data-handle="' + upsell + '"]');
      if (isProductInCart && !isUpsellInCart && $upsellItem.length == 0) {
        addUpsellToCart(upsell);
      }
      else if (!isProductInCart && $upsellItem.length > 0 ) {
        removeUpsellFromCart(upsell);
      }
      //console.log(upsellsShown);
      }//endloop
    });
    
    refreshUpsell();
  }
  
  function checkIfCartHasProduct(handle, bypass) {
    var isProductInCart = false;
    _.filter(cart.items, function(item) {
      if (item.handle == handle ) {
        if ( item.handle != "epic-video-edit" || bypass ){
        isProductInCart = true;
        }
      }
    });
    return isProductInCart;
  }
  
  $(function() {
    // Event handlers
    
    // Options selection
    $(document).on('change', selectors.upsellOptions, function(e) {
      e.preventDefault();
      var variantId = $(this).val();
      //console.log(variantId, $(this).next());
      $(this).next().attr('data-variant-id', variantId);
    });
    
    // Upsell Add to Cart
    $(document).on('click', selectors.upsellAddToCart, function(e) {
      e.preventDefault();
      var data = {
        id: $(this).data('variant-id'), 
        quantity: $(this).attr('addqty')
      }

      $.ajax({
        method: 'POST',
        async: false,
        url: "/cart/add.js",
        data: data,
        dataType: "json",
      }).done(function(item_data) {
        freeVideoRemoved = false;
        freeVideoAdded = false;
        //toggleSidecart("open");
        $(".cart-lds").show();
        setTimeout(function(){ getCart(); }, 1000);
      });
    $('#sidecart .cart-body').animate({ scrollTop: (0) }, 'slow');
    });
  });
  
  return {
    update: update
  }
})(jQuery);